import { getProtocol } from './get-protocol';

// At times, we will be developing the app using different hostnames and ports.
// On docker-compose, the origin might be http://webapp:3001.
// Or, you might be running it on your machine at http://localhost:3000
//
// If the incoming request doesn't include '/dev-api',
// we want it to be for /dev-api on this same server,
// so it can be modified and re-sent, from the server, with appropriate auth cookies,
// to the staging api.

export function stagingBaseUrlFromReq(req) {
  // When using the staging api, we will toggle the '/dev-api' depending on the state of the request.
  // If the incoming request is for localhost:3000/dev-api,
  // then we will strip out '/dev-api' and forward the request to to staging.strava.com.

  return `${getProtocol(req)}://${req.headers.host}/dev-api`;
}

export function stagingBaseUrlFromWindow() {
  const { location } = window;
  const { protocol, hostname, port } = location;

  return `${protocol}//${hostname}:${port}/dev-api`;
}
